<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<!-- eslint-disable vue/no-v-html -->
<template>
	<div class="team-detail__mobile">
		<div class="positon-fixed mt-3"></div>
		<div class="team-header-mobile">
			<h4 class="m-0">
				{{ displayName }}
			</h4>
			<a :href="closeLink" class="close-slider">
				<font-awesome-icon :icon="['custom', 'xmark']" />
			</a>
		</div>
		<div
			ref="swiperContainerTeams"
			class="swiper-container swiper-projekt-detail"
		>
			<div class="swiper-pagination"></div>
			<div class="swiper-wrapper">
				<div class="swiper-slide">
					<NuxtImg
						v-if="currentTeam.PhotoUrl && currentTeam.PhotoUrl.length"
						:src="completeImageUrl(currentTeam.PhotoUrl)"
						class="vh-50"
						loading="lazy"
            :alt="currentTeam.PhotoMetadata['alt']"
            :title="currentTeam.PhotoMetadata['title']"
            sizes="1360px"
					/>
					<NuxtImg
						v-else
						src="/images/logo.gif"
						width="80"
						height="80"
						class="mb-3 swiper-lazy-preloader"
					/>
					<h2 v-if="currentTeam.Title" class="team-detail-quotes">
						<div class="team-detail-quotes" v-html="currentTeam.Title"></div>
					</h2>
					<h2 v-else class="team-detail-quotes">
						Kein Title in der API vorhanden !!!
					</h2>
				</div>
				<template v-for="(part, index) in bodytextParts" :key="'bodytext-' + index">
					<div v-if="part" class="swiper-slide parts">
						<!-- eslint-disable-next-line vue/no-v-html -->
						<div v-html="part"></div>
					</div>
				</template>
				<div class="swiper-slide">
					<div
						v-if="currentTeam.TeaserText"
						class="mb-5"
						v-html="currentTeam.TeaserText"
					></div>
					<div v-if="currentTeam && currentTeam.Projects && currentTeam.Projects.length" class="row">
						<h4>{{ translatedText }}</h4>
					</div>
					<TeamRelation v-if="currentTeam && currentTeam.Projects && currentTeam.Projects.length" :current-team="currentTeam" />
				</div>
				<div
					v-if="currentTeam.Contents && currentTeam.Contents.length > 0"
					class="swiper-slide gallery"
				>
					<div v-for="(item, key) in currentTeam.Contents" :key="key">
						<SlideCta :contact="item" />
					</div>
				</div>

				<div
					v-for="(item, key) in (currentTeam.Contents || [])"
					:key="key"
					class="swiper-slide gallery"
				>
					<SlideImageGallery :item="item" />
				</div>
				<div
					v-if="currentTeam.SpeakerProfil === '1'"
					ref="speakerProfileSlide"
					class="swiper-slide speakerProfileSlide"
				>
					<TeamSpeakerProfil :contact="currentTeam" />
				</div>

				<div class="swiper-slide">
					<GetinTouch :show="showOverlay" :on-close="closeOverlay" />
				</div>
			</div>
		</div>

		<ContactOverlay :show="showOverlay" :on-close="closeOverlay" />
	</div>
</template>

<script>
import { useTeamStore } from '~/composables/useTeamStore'
import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'
import TeamRelation from './TeamRelation'
// import SlideContent from './SlideContent'
import SlideCta from './SlideCta'
import SlideImageGallery from './SlideImageGallery'
import TeamSpeakerProfil from './TeamSpeakerProfil'
import ContactOverlay from './ContactOverlay'
import GetinTouch from './GetinTouch'
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
export default {
	name: 'TeamDetailMobile',
	components: {
		TeamRelation,
		// SlideContent,
		SlideCta,
		SlideImageGallery,
		TeamSpeakerProfil,
		GetinTouch,
		ContactOverlay
	},
	data() {
		return {
			translatedText: '',
			currentSlideIndex: 0,
			totalSlides: 0,
			currentItem: null,
			displayName: '',
			swiper: null,
			swiperInitialized: false,
			shouldInitSwiper: false,
			bodytextParts: []
		}
	},
	computed: {
		currentTeam() {
			return useTeamStore().currentTeam.value || {}
		},
		loadingStatus() {
			return useTeamStore().loadingStatus.value
		},
		truncatedDescription() {
			return this.truncateText(this.currentTeam?.Description || '', 120)
		},
		showOverlay() {
			return useTeamStore().showOverlay.value
		},
		closeLink() {
			return this.$route.path.includes('/en/') ? '/en/team' : '/team'
		}
	},
	watch: {
		currentTeam(newVal) {
			if (newVal && !this.swiperInitialized) {
				this.shouldInitSwiper = true
			}
		}
	},

	updated() {
		if (this.shouldInitSwiper && !this.loadingStatus) {
			this.initSwiper()
			this.shouldInitSwiper = false
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (!this.swiperInitialized) {
				this.initSwiper()
				this.swiperInitialized = true
			}
		})
		this.totalSlides = this.$el.querySelectorAll('.swiper-slide').length - 1
		this.bodytextParts = (this.currentTeam?.Description || '').split(/<hr[^>]*>/)
		this.translateTexts()
	},
	beforeUnmount() {
		document.body.classList.remove('gallery-active')
	},
	methods: {
		updateDisplayName(swiper) {
			if (
				swiper.slides[this.activeSlideIndex] &&
				swiper.slides[this.activeSlideIndex].classList.contains(
					'speakerProfileSlide'
				)
			) {
				this.displayName = `${this.currentTeam.Firstname} on Stage`
			} else {
				this.displayName = this.currentTeam.Firstname
			}
		},
		initSwiper() {
			if (this.swiperInitialized) return
			this.$nextTick(() => {
				this.swiperInitialized = true
				const that = this
				const swiper = new Swiper(this.$refs.swiperContainerTeams, {
					loop: false,
					lazy: true,
					grabCursor: true,
					spaceBetween: 20,
					slidesPerView: 1,
					autoHeight: false,
					modules: [Pagination],
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					on: {
						slideChangeTransitionEnd: () => {
							this.activeSlideIndex = swiper.activeIndex
							that.updateDisplayName(swiper)

							if (
								swiper.slides[this.activeSlideIndex].classList.contains(
									'gallery'
								)
							) {
								document.body.classList.add('gallery-active')
							} else {
								document.body.classList.remove('gallery-active')
							}
						}
					}
				})
				that.activeSlideIndex = swiper.activeIndex
				that.updateDisplayName(swiper)
			})
		},
		truncateText(text, length) {
			if (!text) return ''
			if (text.length <= length) {
				return text
			} else {
				return text.substring(0, length) + '...'
			}
		},
		closeOverlay() {
			useTeamStore().showOverlay.value = false
		},
		translateTexts() {
			this.translatedText = this.$t('projectSentence', {
				category: this.formattedCategories,
				name: this.currentTeam?.Firstname || ''
			})
		},
    completeImageUrl(imagePath) {
      if (!imagePath) {
        return '/images/no-image-placeholder.svg'
      }
      return usePimcoreAssetUrl(imagePath)
    }
	}
}
</script>
<style lang="scss">
.team-detail-active {
	@include media-breakpoint-down(lg) {
		.header::before {
			display: none;
		}
		.navbar-main {
			display: none !important;
		}
		.main-content.container {
			margin: 30px 0;
			padding: 0;
		}
	}
}
.team-header-mobile {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 2rem 0;
	h5 {
		margin-bottom: 0;
	}
	svg {
		font-size: 16px;
		top: 0;
		position: relative;
		color: $white;
	}
}
.team-detail__mobile {
	position: relative;
	height: 100%;
	.swiper-slide {
		object-fit: cover;
		img.vh-65 {
			height: 65vh;
			width: 100%;
			object-fit: cover;
		}
		img.vh-50 {
			height: 50vh;
			width: 100%;
			object-fit: cover;
		}
	}
	.swiper-pagination {
		display: flex;
		justify-content: space-between;
		top: 0px !important;
		z-index: -1;
		height: 20px;
		overflow: hidden;
		text-align: left;
	}

	.swiper-pagination-bullet {
		border-radius: 0;
		flex-grow: 1;
		max-width: 54px;
		width: auto;
		height: 2px;
	}
	.text-image-mobile {
		display: flex;
		flex-direction: column;
		&.inverted {
			flex-direction: column-reverse;
			.text-image-mobile-img {
				margin-bottom: 2rem;
			}
		}
		.text-image-mobile-text {
			margin-bottom: 2rem;
		}
		.text-image-mobile-img {
			img {
				height: 30vh;
			}
		}
	}
	.team-detail-quotes {
		font-size: 24px;
		line-height: 30px;
		text-align: center;
		margin-top: 2rem;
	}
	.close-slider {
		background: transparent;
		border: none;
	}
}
body.gallery-active {
	@include media-breakpoint-down(lg) {
		background-color: $orange;
		transition: background-color 0.5s;
		.team-header-mobile {
			svg {
				color: $black;
			}
		}
		.team-detail__mobile {
			color: $black;
			.input-group-append {
				svg {
					color: $black;
				}
			}
			.form-control {
				background-color: transparent;
				border-color: $black;
			}
			a {
				color: $black;
			}
		}
	}
}
</style>
